import React from "react";
import { useSelector } from "react-redux";
import { selectCurrentProject, selectHomePageData } from "../../../utils";
import styled from "@emotion/styled";
import { BREAKPOINTS } from "../../../utils/styles/breakpoints";
import { HeaderText, ParagraphText } from "../styles";
import { Trans, useTranslation } from "react-i18next";
import { Button } from "../../../components/Button/Button";
import { useNavigate } from "react-router-dom";
import { useMediaMatch } from "rooks";
import sanity from "../../../utils/sanity";
import { COLORS } from "../../../utils/styles/colors";

const Background = styled.div`
  background-color: ${COLORS.CustomGreen};
  padding: 16px 16px;
  border-bottom: solid 2px ${COLORS.CustomSkin};
  ${BREAKPOINTS.MEDIUM} {
    padding: 16px 32px;
  }

  ${BREAKPOINTS.MEDIUM} {
    padding: 28px 32px;
  }

  ${BREAKPOINTS.XLARGE} {
    padding: 28px 56px;
    padding-bottom: 56px;
  }
`;

const Wrapper = styled.div`
  max-width: 1200px;
  margin: 0 auto;

  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 32px;

  ${BREAKPOINTS.LARGE} {
    flex-direction: row;
    justify-content: space-between;
    align-items: flex-start;
  }
`;

const ImageContainer = styled.div`
  display: flex;
  margin: auto;
  img {
    max-width: 100%;
    border-radius: 25px;
    box-shadow: rgba(0, 0, 0, 0.3) 0px 19px 38px,
      rgba(0, 0, 0, 0.22) 0px 15px 12px;
  }
`;

const ContentContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 32px;

  ${BREAKPOINTS.LARGE} {
    max-width: 485px;
    align-items: flex-start;
    gap: 56px;
  }
`;

export const ApartmentSection = () => {
  const { t } = useTranslation();
  const data = useSelector(selectHomePageData);

  const isMediumScreen = useMediaMatch(
    BREAKPOINTS.MEDIUM.replace("@media ", "")
  );
  const isXLargeScreen = useMediaMatch(
    BREAKPOINTS.XLARGE.replace("@media ", "")
  );

  const navigate = useNavigate();
  const currentProject = useSelector(selectCurrentProject);

  const handleClick = () => {
    navigate("/blocks");
  };

  const height = isXLargeScreen ? 512 : isMediumScreen ? 456 : 412;

  return (
    <Background>
      <Wrapper>
        <ContentContainer>
          <HeaderText>
            <Trans ns={"Common"} i18nKey={"HomePageApartmentHeader"}>
              იპოვე <i>სახლი</i> სამგორი პარკ რეზიდენსის პროექტში
            </Trans>
          </HeaderText>
          <ParagraphText>
            <Trans ns={"Common"} i18nKey={"HomePageApartmentDescription"}>
              საცხოვრებელი კომპლექსი მოსკოვის გამზირზე 16,000 კვადრატულ
              ტერიტორიაზე ვითარდება. იგი აერთიანებს სამ 16 სართულიან საცხოვრებელ
              ბლოკს, 4,500 კვ. მ.-მდე გამწვანებულ სივრცეებს (მათ შორის პროექტის
              საკუთარი პატარა ზომის პარკი), საბავშვო და გასართობ მოედნებს, 200
              ერთეულ ღია და დახურული ტიპის საპარკინგე ადგილებს, სასურსათო
              მაღაზიებსა, აფთიაქს და სხვა
            </Trans>
          </ParagraphText>
          <Button action={handleClick} label={t("შეარჩიე კორპუსი")} />
        </ContentContainer>
        <ImageContainer>
          <img
            alt={data?.apartment.altText}
            src={sanity
              .imageUrlBuilder(data!.apartment!.asset._ref)
              .height(height)
              .format("png")
              .fit("scale")
              .url()}
          />
        </ImageContainer>
      </Wrapper>
    </Background>
  );
};
